import React from 'react';
import './ResponsiveError.css'
import DotGrid from './DotGrid';
import ErrorIcon from '../../Assets/Error.svg'


const SizeErrorScreen = () => {
    return ( 

        
        <div className='ResponsiveError'>
                
            <div className='ErrorContent'>
                <div style={{ width: '100%', height: '100vh', position: 'absolute', boxSizing: 'border-box', zIndex: '0' }}>
                <DotGrid
                    dotSize={5}
                    gap={15}
                    baseColor="#311010"
                    activeColor="#ff4f4f"
                    proximity={120}
                    shockRadius={250}
                    shockStrength={5}
                    resistance={750}
                    returnDuration={1.5}
                />
                </div>

                <div className='ErrorMsg'>
                    <img src={ErrorIcon} alt="" />
                    <p className='MsgTitle'>Best Viewed on Larger Screens</p>
                    <p className='MsgDesc'>
                        This website was designed as a desktop experience to showcase its visual layout and animations. Please open it on a larger screen for the best viewing experience.
                    </p>
                </div>
            </div>

        </div>
     );
}
 
export default SizeErrorScreen;